import React, { useState, useCallback, useEffect } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';

import { Input, Button, Tag } from 'src/UIComponents';
import ErrorContainer, { parseAxiosError } from 'src/Layouts/ErrorContainer';
import { updateTag } from 'src/api-services';
import { useTag } from 'src/queries/tag';

import { Colorpicker, TagColor } from './Tag.styles';

function TagDetails(props) {
  const { id } = useParams();
  const { isLoading, error, data: tag = {} } = useTag(id);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { mutate, isSaving } = useMutation(updateTag, {
    onSuccess: () => {
      navigate(-1);
    },
    onMutate: ({ data: updatedTag }) => {
      queryClient.setQueryData(['tags', id], (cachedQuery) => {
        return {
          ...cachedQuery,
          data: {
            ...cachedQuery.data,
            ...updatedTag,
          },
        };
      });
    },
  });
  const [title, setTitle] = useState('');
  const handleTitleChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      if (newValue !== title) {
        setTitle(newValue);
      }
    },
    [setTitle, title]
  );
  const [color, setColor] = useState('#000000');
  const handleColorChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      if (newValue !== color) {
        setColor(newValue);
      }
    },
    [setColor, color]
  );
  useEffect(() => setTitle(tag.title), [tag.title]);
  useEffect(() => setColor(tag.color), [tag.color]);
  const saveForm = useCallback(() => {
    mutate({
      id,
      title,
      color,
    });
  }, [mutate, id, color, title]);

  if (isLoading) {
    return null;
  }

  if (error) {
    return <ErrorContainer {...parseAxiosError(error)} />;
  }

  return (
    <div {...props}>
      <h1>Edit Tag</h1>

      <div className="container mb-2">
        <div className="three columns">Title</div>
        <div className="four columns">
          <Input type="text" value={title} block onChange={handleTitleChange} />
        </div>
      </div>
      <div className="container mb-2">
        <div className="three columns">Preview</div>
        <div className="six columns">
          <Tag color={color}>{title}</Tag>
        </div>
      </div>
      <div className="container mb-2">
        <div className="three columns">Color</div>
        <div
          className="five columns"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1em',
          }}
        >
          <Colorpicker
            value={color}
            title={tag.title}
            block
            onChange={handleColorChange}
          />
          <TagColor className="mv-0" color={color}>
            {color}
          </TagColor>
        </div>
      </div>
      <div className="container mb-2">
        <div className="three columns">&nbsp;</div>
        <div
          className="two-thirds column"
          style={{
            display: 'flex',
          }}
        >
          <Button $color="primary" onClick={saveForm} disabled={isSaving}>
            Save
          </Button>
          &nbsp;
          <Button onClick={() => navigate(-1)} disabled={isSaving}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
}

export default TagDetails;
